import { useMemo } from 'react';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { idBuilder } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
const containerStyle = theme => ({
  maxWidth: '280px',
  boxShadow: theme.tokens.BaseShadowMd,
  padding: '0',
  backgroundColor: theme.tokens.SemColorSurfaceDefault,
  borderRadius: '4px',
  border: `1px solid ${theme.tokens.SemColorBorderMuted}`
});
export const PopoverContainer = props => {
  const theme = useInterstateTheme();
  const {
    children,
    id,
    ...rest
  } = props;
  const style = useMemo(() => containerStyle(theme), [theme]);
  return /*#__PURE__*/_jsx(Box, {
    sx: style,
    className: 'ids-popover-container',
    id: idBuilder('ids-popover-container', id),
    "data-testid": idBuilder('ids-popover-container', rest['data-testid']),
    children: children
  });
};